<template>
  <span>{{ $n(priceDiff, 'currency') }} {{ $tc('base.priceType', exclTax) }}</span>
</template>

<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'price-diff',
  props: {
    offer: Object,
    demand: Object,
  },
  computed: {
    ...mapGetters({
      servicesPrice: 'serviceStore/servicesPrice',
    }),
    priceDiff() {
      return Math.round((this.generatedPrice - this.ceiling) * 100) / 100;
    },
    generatedPrice() {
      return offersHelper.getPrice(this.offer, this.exclTax) + this.servicesPrice;
    },
    ceiling() {
      return offersHelper.getRepaymentCeiling(this.offer, this.demand);
    },
    exclTax() {
      return this.demand.show_price_ht;
    },
  },
};
</script>
